import * as React from 'react';

import './PageButton.scss';

import IPaginationButtonProps from './types';

const PageButton: React.FC<React.PropsWithChildren<IPaginationButtonProps>> = ({
  children,
  className = '',
  disabled,
  onClick,
}) => {
  const itemClass = `pagination-button${disabled ? ' disabled' : ''} ${className}`;
  return (
    <li className={itemClass} onClick={onClick}>
      {children}
    </li>
  );
};

PageButton.displayName = 'PageButton';

export default PageButton;
